/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ShipInputs */

const en_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const ar_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#إطلاق`)
};

const bn_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const de_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const es_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const fr_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const pt_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const zh_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const tr_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const ru_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

const pl_svtag_ship = /** @type {(inputs: Svtag_ShipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#SHIP`)
};

/**
* | output |
* | --- |
* | "#SHIP" |
*
* @param {Svtag_ShipInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_ship = /** @type {((inputs?: Svtag_ShipInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ShipInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_ship(inputs)
	if (locale === "bn") return bn_svtag_ship(inputs)
	if (locale === "de") return de_svtag_ship(inputs)
	if (locale === "es") return es_svtag_ship(inputs)
	if (locale === "fr") return fr_svtag_ship(inputs)
	if (locale === "pt") return pt_svtag_ship(inputs)
	if (locale === "zh") return zh_svtag_ship(inputs)
	if (locale === "tr") return tr_svtag_ship(inputs)
	if (locale === "ru") return ru_svtag_ship(inputs)
	if (locale === "pl") return pl_svtag_ship(inputs)
	return en_svtag_ship(inputs)
});